export default "__VITE_ASSET__c8e3498f__"